export default __webpack_public_path__ + "static/media/daniel.9ee24f30.jpeg";